module.exports = __webpack_public_path__ + "img/curtain_horizontal_25.541adf1e.svg";